import { render, staticRenderFns } from "./WorkFaqDetail.vue?vue&type=template&id=d0ff7dfa&"
import script from "./WorkFaqDetail.vue?vue&type=script&lang=js&"
export * from "./WorkFaqDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports